import {AbstractReleve} from './abstractReleve';
import {Logement} from '../logement';
import {deserializeAs, inheritSerialization} from 'cerialize';


@inheritSerialization(AbstractReleve)
export class ReleveIndividuel extends AbstractReleve{

  @deserializeAs(Logement)
  logement: Logement;

  @deserializeAs('chauffage_marche')
  chauffageMarche: boolean;
  @deserializeAs('refroidissement_marche')
  refroidissementMarche: boolean;

  @deserializeAs('nombre_jour_absence')
  nombreJourAbsence: number;
  @deserializeAs('nombre_occupants')
  nombreOccupants: number;
}
